export default "41,Blokkmark\n42,Fjell i dagen\n43,Grunnlendt\n44,Jorddekt\n45,Organiske jordlag\n46,Konstruert\n98,Ikke relevant\n99,Ikke registrert\n"